import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import SearchBox from '../courses/searchBox';
import { fetchRequest as getCourseRecomAction} from '../../store/courseRecommend/actions'
import { getCourseRecom } from '../../store/courseRecommend/selectors';
import {
    Container, Col, Row, Card, CardImg, CardTitle, CardText, CardGroup, CardFooter,
    CardSubtitle, CardBody, Spinner, Button
} from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.css';
import { Redirect } from 'react-router-dom';
import { FaCheckCircle } from "react-icons/fa";

interface PropsFromState {
    route: any
    data: any
    loading: boolean
    totalDoc: number
}

interface IState {
    redirect: boolean
    term : string
    profession : string
    country : string
    sorting : string
    offset: number
    limit: number
}

interface PropsFromDispatch {
    fetchRequest : typeof getCourseRecomAction
}

type AllProps = PropsFromState & PropsFromDispatch

class HowBenefits extends React.Component<AllProps, IState> {

    constructor(props: AllProps) {
        super(props);
        this.state = {
            term : '',
            profession : '',
            country:'',
            sorting: '',
            offset : 0,
            limit: 4,
            redirect: false
        };
        //this.Search = this.Search.bind(this);
    }

    public componentDidMount() {
        const { fetchRequest: fr, data } = this.props
        var searchParams:any = {};
        searchParams["offset"] = this.state.offset;
        searchParams["limit"] = this.state.limit;
        if (data.length === 0)
           fr(searchParams);
    }

    private Search(d:any) { 

       this.setState({
            offset : 0, 
            redirect : true,
            term : d.searchTerm.toLowerCase(), 
            profession : d.searchProfession, 
            country : d.searchCountry}, () => {
        });
    }
   
    public render() {

        if (this.state.redirect){
            return (
                <Redirect push to={{
                    pathname: '/courses/' ,
                    search :'?term=' + this.state.term  + "&profession=" + encodeURIComponent(this.state.profession) + "&country=" + this.state.country    
                }} />
                // <Redirect to={"/courses?term=" + this.state.term 
                //     + "&profession=" + this.state.profession
                //     + "&country=" + this.state.country    
                //  } />
            )
        }else{
            return (        
                <Container>
                   <h1>How We Benefits You</h1>
                   <hr/>
                   <Row>
                        <Col md="2" xs="3">&nbsp;</Col>
                        <Col md="2" xs="6">
                            <img alt="Skote" src="./images/home-user.png" className="img-fluid card-img"/>
                        </Col>
                        <Col md="6" xs="12">
                            <h4 style={{marginLeft:"40px"}}>PROFESSIONAL USERS</h4>
                            <ul style={{listStyle:"none"}}>
                                <li><FaCheckCircle color="green"/>&nbsp;Easy enrollment</li>
                                <li><FaCheckCircle color="green"/>&nbsp;Cost & time effective</li>
                                <li><FaCheckCircle color="green"/>&nbsp;High quality course materials approved by related professional body</li>
                                <li><FaCheckCircle color="green"/>&nbsp;All attended seminars will be recorded</li>
                            </ul>
                        </Col>
                        <Col md="2" xs="0">&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col md="2" xs="3">&nbsp;</Col>
                        <Col md="2" xs="6">
                            <img alt="Skote" src="./images/home-trainer.png" className="img-fluid card-img"/>
                        </Col>
                        <Col md="6" xs="12">
                            <h4 style={{marginLeft:"40px"}}>TRAINERS</h4>
                            <ul style={{listStyle:"none"}}>
                                <li><FaCheckCircle color="green"/>&nbsp;No location limit</li>
                                <li><FaCheckCircle color="green"/>&nbsp;No worry on class cancellations due to insufficient participants</li>
                                <li><FaCheckCircle color="green"/>&nbsp;Better focus on producing high quality training materials</li>
                            </ul>
                        </Col>
                        <Col md="2" xs="0">&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col md="2" xs="3">&nbsp;</Col>
                        <Col md="2" xs="6">
                            <img alt="Skote" src="./images/home-organization.png" className="img-fluid card-img"/>
                        </Col>
                        <Col md="6" xs="12">
                            <h4 style={{marginLeft:"40px"}}>ORGANIZATION</h4>
                            <ul style={{listStyle:"none"}}>
                                <li><FaCheckCircle color="green"/>&nbsp;Platform can be used to share specific courses to employees</li>
                                <li><FaCheckCircle color="green"/>&nbsp;Customisable learning structure</li>
                                <li><FaCheckCircle color="green"/>&nbsp;Easy access for employers and employees</li>
                            </ul>
                        </Col>
                        <Col md="2" xs="0">&nbsp;</Col>
                    </Row>
                    <br /><br /><br /><br /><br /><br /><br />
                </Container>
            )
        }
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    loading: state.course.ui.loading,
    totalDoc: state.course.ui.totDoc,
    errors: state.course.ui.errors,
    data: getCourseRecom(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    fetchRequest: getCourseRecomAction
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HowBenefits)
